export default "__VITE_ASSET__BpFNwHTg__"